// Adapted from https://github.com/trevorr/catch-unknown/blob/master/src/index.ts
// Trevor Robinson, license ISC

interface IError {
  name: string;
  message: string;
  stack?: string;
  cause?: unknown;
}

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value != null;
}

export function getObjectMessage(obj: Record<string, unknown>): string {
  if (typeof obj.message === "string") {
    return obj.message;
  }
  if (obj.toString !== Object.prototype.toString) {
    return obj.toString(); // eslint-disable-line @typescript-eslint/no-base-to-string
  }
  try {
    return JSON.stringify(obj);
  } catch {
    return String(obj); // eslint-disable-line @typescript-eslint/no-base-to-string
  }
}

export function isError(err: unknown): err is IError {
  return (
    isObject(err) &&
    typeof err.name === "string" &&
    typeof err.message === "string" &&
    (!("stack" in err) || typeof err.stack === "string")
  );
}

export function asError(err: unknown, defaultError?: Error): IError {
  if (!err && !!defaultError) return defaultError;
  if (isError(err)) return err;
  const error = new Error(isObject(err) ? getObjectMessage(err) : String(err));
  error.name = (isObject(err) && err.constructor.name) || typeof err;
  return error;
}

export function toErrorString(err: unknown): string {
  const error = asError(err);
  return `${error.name}: ${error.message}`;
}
